export const T = {
  nav: "nav-root",
  navLogo: "nav-logo",
  navBuy: "nav-buy-btn",
  navTelegram: "nav-telegram-btn",
  navTwitter: "nav-twitter-btn",
  hero: "hero-section",
  heroVideo: "hero-video",
  heroTitle: "hero-title",
  heroBuy: "hero-buy-btn",
  heroCopy: "hero-copy-contract-btn",
  heroPrice: "hero-price-pill",
  ticker: "ticker-marquee",
  stats: "stats-section",
  burnCard: "burn-card",
  burnPercent: "stat-burn-percent",
  burnAmount: "stat-burn-amount",
  burnLink: "burn-dead-wallet-link",
  statMarketCap: "stat-marketcap",
  statVolume: "stat-volume",
  statPrice: "stat-price",
  statLiquidity: "stat-liquidity",
  statHolders: "stat-holders",
  statTxns: "stat-txns",
  reel: "meme-reel-section",
  reelTile: "reel-tile",
  reelSound: "reel-sound-btn",
  lore: "lore-section",
  doItBtn: "do-it-btn",
  doItCount: "do-it-count",
  buy: "how-to-buy-section",
  buyUniswap: "buy-uniswap-btn",
  buyCopy: "buy-copy-contract-btn",
  footer: "footer-section",
  footerTelegram: "footer-telegram",
  footerTwitter: "footer-twitter",
  footerUniswap: "footer-uniswap",
  footerDex: "footer-dexscreener",
  footerExplorer: "footer-explorer",
  footerContract: "footer-contract",
};
